// extracted by mini-css-extract-plugin
export default {"Root":"Sidebar_Root__5Zo5n","WithTop":"Sidebar_WithTop__b69ym"};